import { useMemo } from 'react'
import { useNavigate } from 'react-router'
import { useShallow } from 'zustand/react/shallow'

import { Source } from '@ui/__generated__/graphql'
import { ApolloErrorMessage } from '@ui/components/core/ApolloErrorMessage'
import { TableList } from '@ui/components/elements/TableList/TableList'
import { TableListHeader } from '@ui/components/elements/TableList/TableListHeader'
import { Spinner } from '@ui/components/loaders'
import { sourceTypeToLogoAssetSlug } from '@ui/constants/sources'
import { removeTypename } from '@ui/lib/utils'
import { GetSourcesQuery } from '@ui/loaders/sources'
import { useNavigationStateStore } from '@ui/stores/navigation/NavigationStateStore'

export const Sources = () => {
  const { data, loading, error } = GetSourcesQuery()

  const navigate = useNavigate()
  const { instanceId } = useNavigationStateStore(useShallow((state) => state.params))

  const navigateToSource = (sourceId: number) => {
    navigate(`/instances/${instanceId}/sources/${sourceId}`)
  }

  const sources = useMemo(() => {
    return data?.sources.map((source: Source) => ({
      ...removeTypename(source),
      id: source.id,
      name: source.name,
      type: [sourceTypeToLogoAssetSlug[source.type]],
    }))
  }, [data])

  if (error) {
    return <ApolloErrorMessage error={error} />
  }

  if (loading) {
    return <Spinner />
  }

  return (
    <div className="h-full w-full">
      <>
        <div className="h-full w-full space-y-4">
          <TableListHeader title="Sources" length={data?.sources.length ?? 0} />

          <TableList
            items={sources ?? []}
            logoColumns={['type']}
            onRowClick={(sourceId) => navigateToSource(parseInt(sourceId))}
          />
        </div>
      </>
    </div>
  )
}
